import {Page, NavController} from 'ionic-angular';
import {StudyGuidePage} from '../study-guide/study-guide';
import {WeeklyService} from '../../services/weekly';

/*
  Generated class for the CurrentPage page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Page({
  templateUrl: 'build/pages/current/current.html',
  providers: [WeeklyService],
})
export class CurrentPage {
  weeks;

  constructor(public nav: NavController, weeklyService:WeeklyService) {
    this.weeks = weeklyService.getWeeks();


  }

  goToStudyGuide(url) {
    this.nav.push(StudyGuidePage, {
      guide: {url: url}
    });
  }
  
  openBulletin(url) {
    window.open(url, '_blank');
  }

}
